<!-- 購入後のMasterBookのタイトル・コメント -->
<template>
  <div>
    <!-- チケット名 masterBookSetがある場合は、masterBookSet.nameを表示-->
    <MbNameDisp :name="displayBookName(bookGroup, masterBook)" />
    <!-- チケット名 -->

    <!-- コメント-->
    <MbCommentDisp :comment="displayBookComment(bookGroup, masterBook)" />
    <!-- コメント-->
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TheMyMbNameAndComment",
  setup() {
    const store = useStore();

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    return {
      bookGroup,
      masterBook,
    };
  },
};
</script>
